import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ExtendedSubscriptionInterval, LicenseType } from '@platform-frontend/marketplace';
import { TypedChanges } from '@platform-frontend/util';
import { tap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'yat-license-type-selector',
  templateUrl: './license-type-selector.component.html',
  styleUrls: ['./license-type-selector.component.scss']
})
export class LicenseTypeSelectorComponent implements OnInit, OnChanges {
  @Input()
  licenseTypes: LicenseType[] = [];

  @Input()
  selectedLicenseType: LicenseType | null = null;

  @Input()
  disableSelection: boolean = false;

  @Output()
  licenseTypeChanged: EventEmitter<string | null> = new EventEmitter();

  licenseTypeControl = new FormControl<string | null>(null, { nonNullable: true });

  ngOnInit(): void {
    this.licenseTypeControl.valueChanges
      .pipe(
        tap(licenseType => {
          this.licenseTypeChanged.next(licenseType);
        }),
        untilDestroyed(this)
      )
      .subscribe();
  }

  ngOnChanges(changes: TypedChanges<LicenseTypeSelectorComponent>): void {
    if (changes.selectedLicenseType && this.selectedLicenseType) {
      this.licenseTypeControl.setValue(this.selectedLicenseType.licenseTypeId, { emitEvent: false });
    }
  }

  getSubscriptionInterval(licenseType: LicenseType): ExtendedSubscriptionInterval | null {
    return licenseType.kind.type === 'SUBSCRIPTION' ? licenseType.kind.subscriptionInterval : null;
  }
}
